import { render, staticRenderFns } from "./PayrollManagerView.vue?vue&type=template&id=83a1d644&scoped=true"
import script from "./PayrollManagerView.vue?vue&type=script&lang=js"
export * from "./PayrollManagerView.vue?vue&type=script&lang=js"
import style0 from "./PayrollManagerView.vue?vue&type=style&index=0&id=83a1d644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a1d644",
  null
  
)

export default component.exports